import { useEffect, useRef } from 'react';
import { useCurrentEditor } from '@tiptap/react';
import { useTranslation } from '@hooks';
import { getPlaceholderByToken } from '@constants/placeholders';
import { buildPlaceholderInsertion } from '@helpers/text-editor';

export const useInsertPlaceholder = () => {
    const { t } = useTranslation();
    const { editor } = useCurrentEditor();
    const hasBeenFocused = useRef(false);

    useEffect(() => {
        if (!editor) return undefined;
        const markFocused = () => {
            hasBeenFocused.current = true;
        };
        editor.on('focus', markFocused);
        return () => editor.off('focus', markFocused);
    }, [editor]);

    return (token, { padded = false } = {}) => {
        if (!editor) return;
        const def = getPlaceholderByToken(token);
        const label = def ? t(def.labelKey) : token;
        editor.commands.focus(hasBeenFocused.current ? null : 'end');
        const { doc } = editor.state;
        const { from, to } = editor.state.selection;
        editor
            .chain()
            .insertContent(
                buildPlaceholderInsertion({
                    token,
                    label,
                    padded,
                    characterBefore: from > 0 ? doc.textBetween(from - 1, from, ' ', ' ') : '',
                    characterAfter: to < doc.content.size ? doc.textBetween(to, to + 1, ' ', ' ') : '',
                }),
            )
            .run();
    };
};
